export default __webpack_public_path__ + "static/media/ticket2.7e2cf467.svg";